export type SportKey = 'mlb' | 'pga'

/** Matches sidebar / header sport badge colors. */
export function sportChipActiveClass(sport: SportKey): string {
  switch (sport) {
    case 'pga':
      return 'bg-emerald-600 text-white shadow-md shadow-emerald-600/20'
    case 'mlb':
    default:
      return 'bg-blue-600 text-white shadow-md shadow-blue-600/20'
  }
}
